/**
 * Delivery Zone Checker — Cascina Fraschina Bio
 *
 * Poligoni estratti dal KML della mappa Google:
 * https://www.google.com/maps/d/u/0/viewer?mid=18WBkfkimfujsgUMALirLOrmBKuXQFUU
 *
 * Slot consegna:
 *   Ordini entro lunedì 11:00  → ritiro martedì @ Radici Bottega Bio, consegna mercoledì a domicilio
 *   Ordini entro giovedì 11:00 → ritiro sabato @ Radici Bottega Bio (o Cascina Linterno per Milano 1-2-3-4)
 */

var MILANO_ZONES = ["MILANO 1", "MILANO 2", "MILANO 3", "MILANO 4"];

var PICKUP_POINTS = {
	radici: "Radici Bottega Bio",
	linterno: "Cascina Linterno",
};

var DELIVERY_ZONES = [
	{
		name: "ABBIATEGRASSO & DINTORNI",
		deliveryTime: "dalle 17:00",
		polygon: [
			[8.8679195, 45.3873517],
			[8.95787, 45.35455],
			[8.9942623, 45.3738474],
			[8.9235378, 45.4731249],
			[8.8541866, 45.4591595],
			[8.8679195, 45.3873517],
		],
	},
	{
		name: "MILANO 1",
		deliveryTime: "8:00\u201311:30",
		polygon: [
			[9.1637592, 45.4616426],
			[8.9738163, 45.4025851],
			[8.9942623, 45.3738474],
			[9.1917908, 45.4347971],
			[9.1971922, 45.43825],
			[9.2011892, 45.4515682],
			[9.1831434, 45.4519147],
			[9.1775003, 45.4529835],
			[9.1763408, 45.4536783],
			[9.1744088, 45.4553064],
			[9.1712312, 45.4572981],
			[9.1637592, 45.4616426],
		],
	},
	{
		name: "MILANO 2",
		deliveryTime: "9:30\u201312:30",
		polygon: [
			[9.2011892, 45.4515682],
			[9.1971922, 45.43825],
			[9.2148361, 45.4445533],
			[9.2246499, 45.4622129],
			[9.2248975, 45.4808349],
			[9.2189323, 45.4881162],
			[9.2054569, 45.4745758],
			[9.2073452, 45.4620556],
			[9.2011892, 45.4515682],
		],
	},
	{
		name: "MILANO 3",
		deliveryTime: "10:30\u201313:30",
		polygon: [
			[9.212495, 45.4817225],
			[9.2189323, 45.4881162],
			[9.1928129, 45.4977062],
			[9.1629438, 45.4980672],
			[9.1438893, 45.492893],
			[9.1513563, 45.4896409],
			[9.1694748, 45.4782346],
			[9.1726424, 45.478767],
			[9.1764619, 45.4765101],
			[9.180968, 45.4776235],
			[9.1825129, 45.4811442],
			[9.1941001, 45.4794591],
			[9.2054178, 45.4743649],
			[9.212495, 45.4817225],
		],
	},
	{
		name: "MILANO 4",
		deliveryTime: "11:00\u201315:00",
		polygon: [
			[9.1635582, 45.461624],
			[9.1665834, 45.4675005],
			[9.1665324, 45.4718664],
			[9.1697512, 45.473973],
			[9.1680345, 45.4761698],
			[9.1694077, 45.4782763],
			[9.1456329, 45.4929138],
			[9.050533, 45.4894541],
			[9.0319934, 45.4526175],
			[8.9741436, 45.4380448],
			[8.9571492, 45.4259983],
			[8.9738003, 45.4026209],
			[9.1635582, 45.461624],
		],
	},
	{
		name: "MILANO CENTRO",
		deliveryTime: "10:00\u201315:00",
		polygon: [
			[9.1693808, 45.4782255],
			[9.1680075, 45.476119],
			[9.1697242, 45.4739222],
			[9.1665055, 45.4718156],
			[9.1667416, 45.4675041],
			[9.1637163, 45.4616276],
			[9.1774574, 45.4529685],
			[9.1831005, 45.4518997],
			[9.2011463, 45.4515532],
			[9.2073023, 45.4620406],
			[9.205414, 45.4745608],
			[9.1940572, 45.4794291],
			[9.18247, 45.4811142],
			[9.1809251, 45.4775935],
			[9.176419, 45.4764801],
			[9.1725995, 45.478737],
			[9.1693808, 45.4782255],
		],
	},
];

// CAP ammessi (whitelist)
var ALLOWED_CAPS = new Set([
	// Milano città
	"20121",
	"20122",
	"20123",
	"20124",
	"20125",
	"20126",
	"20127",
	"20128",
	"20129",
	"20131",
	"20132",
	"20134",
	"20135",
	"20136",
	"20137",
	"20138",
	"20139",
	"20140",
	"20142",
	"20143",
	"20144",
	"20145",
	"20146",
	"20147",
	"20148",
	"20149",
	"20153",
	"20154",
	"20155",
	"20156",
	"20157",
	"20159",
	"20160",
	// Hinterland ovest
	"20090",
	"20094",
	"20089",
	// Abbiategrasso & Dintorni
	"20080",
	"20081",
	"20082",
	"20083",
	"20084",
	"20086",
	"20087",
	"20088",
]);

// Mapping CAP → nome zona (approssimativo)
var CAP_TO_ZONE = {
	20080: "ABBIATEGRASSO & DINTORNI",
	20081: "ABBIATEGRASSO & DINTORNI",
	20082: "ABBIATEGRASSO & DINTORNI",
	20083: "ABBIATEGRASSO & DINTORNI",
	20084: "ABBIATEGRASSO & DINTORNI",
	20086: "ABBIATEGRASSO & DINTORNI",
	20087: "ABBIATEGRASSO & DINTORNI",
	20088: "ABBIATEGRASSO & DINTORNI",
	20089: "MILANO 4",
	20090: "MILANO 4",
	20094: "MILANO 4",
	20121: "MILANO CENTRO",
	20122: "MILANO CENTRO",
	20123: "MILANO CENTRO",
	20124: "MILANO CENTRO",
	20125: "MILANO CENTRO",
	20126: "MILANO CENTRO",
	20127: "MILANO CENTRO",
	20128: "MILANO CENTRO",
	20129: "MILANO CENTRO",
	20135: "MILANO 1",
	20136: "MILANO 1",
	20138: "MILANO 1",
	20139: "MILANO 1",
	20140: "MILANO 1",
	20131: "MILANO 2",
	20132: "MILANO 2",
	20134: "MILANO 2",
	20153: "MILANO 3",
	20154: "MILANO 3",
	20155: "MILANO 3",
	20157: "MILANO 3",
	20159: "MILANO 3",
	20137: "MILANO 4",
	20142: "MILANO 4",
	20143: "MILANO 4",
	20144: "MILANO 4",
	20145: "MILANO 4",
	20146: "MILANO 4",
	20147: "MILANO 4",
	20148: "MILANO 4",
	20149: "MILANO 4",
	20156: "MILANO 4",
	20160: "MILANO 4",
};

/**
 * Ray-casting point-in-polygon algorithm.
 * polygon = [[lng, lat], ...]
 */
function pointInPolygon(lng, lat, polygon) {
	var inside = false;
	for (var i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
		var xi = polygon[i][0],
			yi = polygon[i][1];
		var xj = polygon[j][0],
			yj = polygon[j][1];
		var intersect =
			yi > lat !== yj > lat && lng < ((xj - xi) * (lat - yi)) / (yj - yi) + xi;
		if (intersect) inside = !inside;
	}
	return inside;
}

/**
 * Trova la zona di consegna per una coordinata.
 */
function findDeliveryZone(lng, lat) {
	for (var i = 0; i < DELIVERY_ZONES.length; i++) {
		if (pointInPolygon(lng, lat, DELIVERY_ZONES[i].polygon)) {
			return DELIVERY_ZONES[i];
		}
	}
	return null;
}

/**
 * Trova la zona per un CAP tramite il mapping CAP → zona.
 */
function findZoneForCap(cap) {
	var zoneName = CAP_TO_ZONE[String(cap).trim()];
	if (!zoneName) return null;
	for (var i = 0; i < DELIVERY_ZONES.length; i++) {
		if (DELIVERY_ZONES[i].name === zoneName) return DELIVERY_ZONES[i];
	}
	return null;
}

/**
 * Verifica rapida se un CAP è nella whitelist.
 */
function isCapAllowed(cap) {
	return ALLOWED_CAPS.has(String(cap).trim());
}

// ── Logica slot consegna ──────────────────────────────────────────────

var GIORNI_IT = [
	"Domenica",
	"Luned\u00ec",
	"Marted\u00ec",
	"Mercoled\u00ec",
	"Gioved\u00ec",
	"Venerd\u00ec",
	"Sabato",
];
var MESI_IT = [
	"Gennaio",
	"Febbraio",
	"Marzo",
	"Aprile",
	"Maggio",
	"Giugno",
	"Luglio",
	"Agosto",
	"Settembre",
	"Ottobre",
	"Novembre",
	"Dicembre",
];

function formatDateIT(date) {
	return (
		GIORNI_IT[date.getDay()] +
		" " +
		date.getDate() +
		" " +
		MESI_IT[date.getMonth()]
	);
}

function addDays(date, n) {
	var d = new Date(date.getTime());
	d.setDate(d.getDate() + n);
	return d;
}

/**
 * Calcola il prossimo slot di consegna a domicilio disponibile.
 *
 * La consegna a domicilio avviene sempre il mercoledì con cutoff
 * entro lunedì ore 11:00 (ritiro interno il martedì @ Radici Bottega Bio).
 *
 * Ritorna:
 * {
 *   slot: 1,
 *   cutoffDate: Date,
 *   cutoffLabel: "Lunedì 7 Aprile ore 11:00",
 *   pickupDate: Date,
 *   pickupLabel: "Martedì 8 Aprile",
 *   deliveryDate: Date,
 *   deliveryLabel: "Mercoledì 9 Aprile",
 *   hasHomeDelivery: true,
 * }
 */
function getNextDeliverySlot(now) {
	if (!now) now = new Date();

	var romeStr = now.toLocaleString("en-US", { timeZone: "Europe/Rome" });
	var rome = new Date(romeStr);
	var day = rome.getDay();
	var hour = rome.getHours();

	function daysUntil(targetDay) {
		var diff = targetDay - day;
		if (diff < 0) diff += 7;
		return diff;
	}

	var daysToMon = daysUntil(1);
	var monCutoffPassed = daysToMon === 0 && hour >= 11;

	var nextMon = addDays(rome, monCutoffPassed ? 7 : daysToMon);
	var pickupDate = addDays(nextMon, 1);
	var deliveryDate = addDays(nextMon, 2);

	return {
		slot: 1,
		cutoffDate: nextMon,
		cutoffLabel: formatDateIT(nextMon) + " ore 11:00",
		pickupDate: pickupDate,
		pickupLabel: formatDateIT(pickupDate),
		deliveryDate: deliveryDate,
		deliveryLabel: formatDateIT(deliveryDate),
		hasHomeDelivery: true,
	};
}

/**
 * Calcola il prossimo slot di ritiro disponibile.
 *
 * Slot 1: ordini entro lunedì 11:00 → ritiro martedì @ Radici Bottega Bio
 * Slot 2: ordini entro giovedì 11:00 → ritiro sabato @ Radici Bottega Bio
 *         (o Cascina Linterno per Milano 1-4)
 *
 * Ritorna:
 * {
 *   slot: 1 | 2,
 *   cutoffDate: Date,
 *   cutoffLabel: "Lunedì 7 Aprile ore 11:00" | "Giovedì 10 Aprile ore 11:00",
 *   pickupDate: Date,
 *   pickupLabel: "Martedì 8 Aprile" | "Sabato 12 Aprile",
 *   deliveryDate: null,
 *   deliveryLabel: null,
 *   hasHomeDelivery: false,
 * }
 */
function getNextPickupSlot(now) {
	if (!now) now = new Date();

	var romeStr = now.toLocaleString("en-US", { timeZone: "Europe/Rome" });
	var rome = new Date(romeStr);
	var day = rome.getDay();
	var hour = rome.getHours();

	function daysUntil(targetDay) {
		var diff = targetDay - day;
		if (diff < 0) diff += 7;
		return diff;
	}

	var daysToMon = daysUntil(1);
	var daysToThu = daysUntil(4);

	var monCutoffPassed = daysToMon === 0 && hour >= 11;
	var thuCutoffPassed = daysToThu === 0 && hour >= 11;

	var nextMon = addDays(rome, monCutoffPassed ? 7 : daysToMon);
	var nextThu = addDays(rome, thuCutoffPassed ? 7 : daysToThu);

	if (nextMon <= nextThu) {
		var pickupDate = addDays(nextMon, 1);
		return {
			slot: 1,
			cutoffDate: nextMon,
			cutoffLabel: formatDateIT(nextMon) + " ore 11:00",
			pickupDate: pickupDate,
			pickupLabel: formatDateIT(pickupDate),
			deliveryDate: null,
			deliveryLabel: null,
			hasHomeDelivery: false,
		};
	} else {
		var satDate = addDays(nextThu, 2);
		return {
			slot: 2,
			cutoffDate: nextThu,
			cutoffLabel: formatDateIT(nextThu) + " ore 11:00",
			pickupDate: satDate,
			pickupLabel: formatDateIT(satDate),
			deliveryDate: null,
			deliveryLabel: null,
			hasHomeDelivery: false,
		};
	}
}

/**
 * Verifica se la zona può ritirare anche a Cascina Linterno (solo Milano 1-2-3-4).
 */
function canPickupLinterno(zoneName) {
	return MILANO_ZONES.indexOf(zoneName) !== -1;
}

window.FrascaDeliveryZones = {
	DELIVERY_ZONES: DELIVERY_ZONES,
	ALLOWED_CAPS: ALLOWED_CAPS,
	CAP_TO_ZONE: CAP_TO_ZONE,
	PICKUP_POINTS: PICKUP_POINTS,
	MILANO_ZONES: MILANO_ZONES,
	pointInPolygon: pointInPolygon,
	findDeliveryZone: findDeliveryZone,
	findZoneForCap: findZoneForCap,
	isCapAllowed: isCapAllowed,
	getNextDeliverySlot: getNextDeliverySlot,
	getNextPickupSlot: getNextPickupSlot,
	canPickupLinterno: canPickupLinterno,
	formatDateIT: formatDateIT,
};

var MIN_SHIPPING_TOTAL = 2500; // €25 in centesimi

function getCartTotal() {
	var container = document.getElementById("delivery-zone-check");
	if (!container) return null;
	var total = parseInt(container.getAttribute("data-cart-total"), 10);
	return isNaN(total) ? null : total;
}

function isShippingBlocked() {
	var total = getCartTotal();
	return total !== null && total < MIN_SHIPPING_TOTAL;
}

function showMinOrderMessage() {
	var result = document.getElementById("delivery-zone-result");
	if (!result) return;
	result.classList.remove("hidden");
	result.className =
		"delivery-zone-check__result delivery-zone-check__result--error";
	result.textContent =
		"La consegna a domicilio è disponibile solo per ordini da almeno 25 €. Aggiungi altri prodotti al carrello oppure scegli il ritiro in negozio.";
}

function getSelectedMethod() {
	var radios = document.querySelectorAll('input[name="delivery-method"]');
	for (var i = 0; i < radios.length; i++) {
		if (radios[i].checked) return radios[i].value;
	}
	return "shipping";
}

function pickupScheduleHtml(zone, slot) {
	var hasLinterno = zone ? canPickupLinterno(zone.name) : false;
	var html = '<div class="delivery-zone-check__schedule">';
	html += '<div class="delivery-zone-check__schedule-row">';
	html += '<span class="delivery-zone-check__schedule-icon">&#127979;</span> ';
	html +=
		"<span><strong>Ritiro:</strong> " +
		slot.pickupLabel +
		" presso <em>" +
		PICKUP_POINTS.radici +
		"</em></span>";
	html += "</div>";
	if (hasLinterno && !slot.hasHomeDelivery) {
		html += '<div class="delivery-zone-check__schedule-row">';
		html += '<span class="delivery-zone-check__schedule-icon">&#127806;</span> ';
		html +=
			"<span>Oppure ritiro presso <em>" + PICKUP_POINTS.linterno + "</em></span>";
		html += "</div>";
	}
	html += '<div class="delivery-zone-check__cutoff">';
	html += "Ordina entro <strong>" + slot.cutoffLabel + "</strong>";
	html += "</div>";
	html += "</div>";
	return html;
}

function checkCap() {
	var input = document.getElementById("delivery-cap-input");
	var result = document.getElementById("delivery-zone-result");
	var checkoutBtn = document.getElementById("checkout");
	if (!input || !result) return;

	var cap = input.value.trim();
	var method = getSelectedMethod();

	if (method === "shipping" && isShippingBlocked()) {
		showMinOrderMessage();
		var pickupRadio = document.getElementById("delivery-method-pickup");
		var shippingRadio = document.getElementById("delivery-method-shipping");
		if (pickupRadio) pickupRadio.checked = true;
		if (shippingRadio) shippingRadio.disabled = true;
		return;
	}

	if (cap.length !== 5 || /^\d{5}$/.test(cap) === false) {
		result.classList.remove("hidden");
		result.className =
			"delivery-zone-check__result delivery-zone-check__result--error";
		result.textContent = "Inserisci un CAP valido (5 cifre)";
		return;
	}

	var allowed = isCapAllowed(cap);
	var zone = findZoneForCap(cap);
	var slot =
		method === "shipping" && allowed
			? getNextDeliverySlot()
			: getNextPickupSlot();
	var zoneName = zone ? zone.name : null;
	result.classList.remove("hidden");

	// ── Ritiro in negozio: il CAP incide solo sulla scelta del punto di ritiro ──
	if (method === "pickup") {
		var html = "<strong>&#127979;</strong> Hai scelto il ritiro in negozio.";
		if (zoneName) {
			html += " Il tuo CAP rientra nella zona <strong>" + zoneName + "</strong>.";
		} else {
			html += " Potrai ritirare presso <em>" + PICKUP_POINTS.radici + "</em>.";
		}
		html += pickupScheduleHtml(zone, slot);

		result.className =
			"delivery-zone-check__result delivery-zone-check__result--success";
		result.innerHTML = html;
		if (checkoutBtn) checkoutBtn.disabled = false;
		return;
	}

	// ── Spedizione a domicilio ──
	if (!allowed) {
		var infoHtml =
			"<strong>&#8505;</strong> Il tuo CAP non rientra nelle nostre zone di consegna a domicilio standard." +
			"<br>Puoi comunque completare l&rsquo;ordine: verrai ricontattato per concordare le modalit&agrave; di consegna.";

		result.className =
			"delivery-zone-check__result delivery-zone-check__result--info";
		result.innerHTML = infoHtml;
		if (checkoutBtn) checkoutBtn.disabled = false;
		return;
	}

	var displayZoneName = zoneName || "la tua zona";

	var html2 =
		"<strong>&#10003;</strong> Il tuo CAP rientra nella zona <strong>" +
		displayZoneName +
		"</strong>";

	if (slot.hasHomeDelivery) {
		html2 += '<div class="delivery-zone-check__schedule">';
		html2 += '<div class="delivery-zone-check__schedule-row">';
		html2 += '<span class="delivery-zone-check__schedule-icon">&#128666;</span> ';
		html2 += "<span><strong>Consegna a domicilio:</strong> " + slot.deliveryLabel;
		if (zone && zone.deliveryTime) {
			html2 += " <em>(" + zone.deliveryTime + ")</em>";
		}
		html2 += "</span></div>";
		html2 += '<div class="delivery-zone-check__schedule-row">';
		html2 += '<span class="delivery-zone-check__schedule-icon">&#127979;</span> ';
		html2 +=
			"<span><strong>Ritiro:</strong> " +
			slot.pickupLabel +
			" presso <em>" +
			PICKUP_POINTS.radici +
			"</em></span>";
		html2 += "</div>";
		html2 += '<div class="delivery-zone-check__cutoff">';
		html2 += "Ordina entro <strong>" + slot.cutoffLabel + "</strong>";
		html2 += "</div>";
		html2 += "</div>";
	} else {
		html2 += pickupScheduleHtml(zone, slot);
		html2 += '<div class="delivery-zone-check__note">';
		html2 +=
			"<small>In questo slot non &egrave; prevista la consegna a domicilio.</small>";
		html2 += "</div>";
	}

	result.className =
		"delivery-zone-check__result delivery-zone-check__result--success";
	result.innerHTML = html2;
	if (checkoutBtn) checkoutBtn.disabled = false;
}

function initDeliveryZoneCheck() {
	document.addEventListener("click", function (e) {
		if (e.target && e.target.closest && e.target.closest("#delivery-cap-check")) {
			checkCap();
		}
	});

	document.addEventListener("keydown", function (e) {
		if (e.key === "Enter" && e.target && e.target.id === "delivery-cap-input") {
			e.preventDefault();
			checkCap();
		}
	});

	document.addEventListener("change", function (e) {
		if (e.target && e.target.name === "delivery-method") {
			if (e.target.value === "shipping" && isShippingBlocked()) {
				var pickupRadio = document.getElementById("delivery-method-pickup");
				if (pickupRadio) pickupRadio.checked = true;
				e.target.disabled = true;
				showMinOrderMessage();
				return;
			}
			var input = document.getElementById("delivery-cap-input");
			if (input && input.value.trim().length === 5) {
				checkCap();
			}
		}
	});
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", initDeliveryZoneCheck);
} else {
	initDeliveryZoneCheck();
}
